<div class="account-content">
    <div class="login-wrapper bg-img">
        <div class="login-content">
            <form [formGroup]="formGroup" (ngSubmit)="onLogin()">
                <div class="login-userset card p-5 login-card">
                    <div class="login-logo logo-normal">
                        <img src="assets/img/Clienta-logo.png" alt="img">
                    </div>
                    <div class="login-userheading text-center mt-5">
                        <h3>Sign In</h3>
                        <h4>Access the CLIENTA admin panel using your company profile.</h4>
                    </div>
                    <div class="form-login mt-3">
                        <button type="submit" class="btn btn-login d-flex align-items-center justify-content-center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21">
                                <title>MS-SymbolLockup</title>
                                <rect x="1" y="1" width="9" height="9" fill="#f25022" />
                                <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
                                <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
                                <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
                            </svg>&nbsp;Sign In</button>
                    </div>
<!--                    <div class="form-sociallink">-->
<!--                        <div class="my-4 d-flex justify-content-center align-items-center copyright-text">-->
<!--                            <p>Copyright &copy; 2023 Peterson. All rights reserved</p>-->
<!--                        </div>-->
<!--                    </div>-->
                </div>
            </form>
        </div>
    </div>
</div>
